export enum ClientStatuses {
    Active = "Active",
    Disabled = "Disabled",
}
